module.exports = __webpack_public_path__ + "static/media/dribble.88df67b5.svg";